import { render, staticRenderFns } from "./form-general-info.vue?vue&type=template&id=76952a8a&lang=pug&"
import script from "./form-general-info.vue?vue&type=script&lang=js&"
export * from "./form-general-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports